var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"float-left",attrs:{"color":"grey","outlined":""},on:{"click":_vm.returnToPreviousRoute}},[_vm._v(" Cancelar ")])}
var staticRenderFns = []

export { render, staticRenderFns }